import { memo } from 'react';

import SettingsIconSVG from '@/assets/settings-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ISettingsIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={SettingsIconSVG} {...props} />;

export const SettingsIcon = memo(ISettingsIcon) as typeof ISettingsIcon;
